/**
 * ████████╗ ██████╗ ██╗     ██╗███╗   ██╗ ██████╗
 * ╚══██╔══╝██╔═══██╗██║     ██║████╗  ██║██╔═══██╗
 *    ██║   ██║   ██║██║     ██║██╔██╗ ██║██║   ██║
 *    ██║   ██║   ██║██║     ██║██║╚██╗██║██║   ██║
 *    ██║   ╚██████╔╝███████╗██║██║ ╚████║╚██████╔╝
 *    ╚═╝    ╚═════╝ ╚══════╝╚═╝╚═╝  ╚═══╝ ╚═════╝
 *
 * (c) Copyright 2021-present Rakuten Kobo Inc. (https://www.kobo.com)
 */

// -----------------------------------------------------------------------------
// CONSTANTS
// -----------------------------------------------------------------------------

/**
 * Tag for log output etc.
 *
 * @type {string}
 * @default
 */
const TAG = '[service/security]';

/**
 * Available error codes/messages
 *
 * @type {object}
 * @default
 */
const SECURITY_ERROR_CODES = Object.freeze({
  URL_EPUB_NOT_ALLOWED: {
    message: 'The ePub is to be loaded from an unauthorized domain. This is not allowed.'
  },

  UNABLE_TO_LOAD_WHITELIST: {
    message: 'This service is currently unavailable due to technical problems.'
  }
});


// -----------------------------------------------------------------------------
// EXPORTS
// -----------------------------------------------------------------------------

export {
  SECURITY_ERROR_CODES,
  TAG
};
